import './spinner.less'

const Spinner: React.FC = () => (
  <div className='spinner-wrapper' data-test-id='spinner-wrapper'>
    <div className='spinner'>
      <div className='spinner__core' />
    </div>
    <span className='spinner__label'>Initializing...</span>
  </div>
)

export default Spinner
